import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import useEntityTitles from "hooks/useEntityTitles";
import { Link, Spinner } from "components/common";
import { Table } from "components/bootstrap";
import { formatCount } from "components/inputs/helpers/InputThroughputUtils";
import useInputMetrics from "hooks/useInputMetrics";
import Routes from "routing/Routes";
const StreamColumn = styled.col`
  width: 80%;
`;
const MessagesColumn = styled.col`
  width: 20%;
`;
const MessageCountHeadCell = styled.th`
  text-align: right;
`;
const MessageCountCell = styled.td`
  font-variant-numeric: tabular-nums;
  text-align: right;
`;
const MessagesPerStreamSection = ({ input }) => {
  var _a;
  const { t } = useTranslation("inputs");
  const { metricsByInputId, isInitialLoading, isError } = useInputMetrics([input.id], ["messages_per_stream"]);
  const messagesPerStream = (_a = metricsByInputId[input.id]) == null ? void 0 : _a.messages_per_stream;
  const streamIds = messagesPerStream ? Object.keys(messagesPerStream) : [];
  const titleEntities = streamIds.map((id) => ({ id, type: "streams" }));
  const { titlesById, isInitialLoading: areTitlesLoading } = useEntityTitles(titleEntities);
  if (isInitialLoading && !messagesPerStream) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (isError) {
    return /* @__PURE__ */ React.createElement("p", null, t("overview.sections.could_not_load_messages_per_stream"));
  }
  if (!messagesPerStream || streamIds.length === 0) {
    return /* @__PURE__ */ React.createElement("p", null, t("overview.sections.no_messages_per_stream"));
  }
  const sortedEntries = Object.entries(messagesPerStream).sort(([, a], [, b]) => b - a);
  return /* @__PURE__ */ React.createElement(Table, { bordered: true, condensed: true }, /* @__PURE__ */ React.createElement("colgroup", null, /* @__PURE__ */ React.createElement(StreamColumn, null), /* @__PURE__ */ React.createElement(MessagesColumn, null)), /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("overview.sections.stream")), /* @__PURE__ */ React.createElement(MessageCountHeadCell, null, t("overview.sections.messages")))), /* @__PURE__ */ React.createElement("tbody", null, sortedEntries.map(([streamId, count]) => {
    const title = titlesById[streamId];
    const label = title != null ? title : areTitlesLoading ? streamId : t("overview.sections.deleted_stream", { streamId });
    return /* @__PURE__ */ React.createElement("tr", { key: streamId }, /* @__PURE__ */ React.createElement("td", null, title ? /* @__PURE__ */ React.createElement(Link, { to: Routes.stream_view(streamId) }, label) : label), /* @__PURE__ */ React.createElement(MessageCountCell, null, formatCount(count)));
  })));
};
export default MessagesPerStreamSection;
